var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.66667H9.25M3.75 7H5.125M3.75 12.3333H6.5M5.125 2.33333H2.375C2.01033 2.33333 1.66059 2.47381 1.40273 2.72386C1.14487 2.97391 1 3.31304 1 3.66667V13.6667C1 14.0203 1.14487 14.3594 1.40273 14.6095C1.66059 14.8595 2.01033 15 2.375 15H10.625C10.9897 15 11.3394 14.8595 11.5973 14.6095C11.8551 14.3594 12 14.0203 12 13.6667V3.66667C12 3.31304 11.8551 2.97391 11.5973 2.72386C11.3394 2.47381 10.9897 2.33333 10.625 2.33333H8.21875M5.125 2.33333V1M5.125 2.33333V3.66667",
    stroke: "#7D7D7C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.f89f616639d601136a90b019e70295ba.svg";
export { ForwardRef as ReactComponent };